import { useTranslations } from '../../localization/useTranslations';
import Breadcrumbs from '../../components/breadcrumb/Breadcrumb';
import React, { useEffect, useState } from 'react';

export interface BrandsPageProps {
  brands: {
    name: string;
    description: string;
    url: string;
  }[];
}

const BrandsPage: React.FC<BrandsPageProps> = ({ brands }) => {
  const [firstLetters, setFirstLetters] = useState<string[]>([]);
  const translations = useTranslations();

  useEffect(() => {
    const letters = brands
      .map((brand) => brand.name.charAt(0).toUpperCase())
      .filter((letter, index, self) => self.indexOf(letter) === index)
      .sort();
    setFirstLetters(letters);
  }, [brands]);

  return (
    <div className="ecom-brands">
      <Breadcrumbs
        firstHasPreIcon
        breadcrumbs={[
          {
            label: translations?.ecommerce?.shopping || 'Shopping',
            path: '/market/',
          },
          {
            label: translations?.ecommerce?.brands || 'Brands',
            path: '/market/znacky/',
          },
        ]}
      />
      <ul className="ecom-brands__wrapper">
        {firstLetters.map((letter, index) => (
          <li key={index}>
            <h4 className="ecom-brands__brand-title">{letter}</h4>
            <ul className="ecom-brands__brand-items">
              {brands
                .filter((brand) => brand.name.charAt(0).toUpperCase() === letter)
                .map((brand, index) => (
                  <li key={index}>
                    <a href={brand.url} className="link-16">
                      {brand.name}
                    </a>
                  </li>
                ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BrandsPage;
